import { Slide } from '@/components/core/Slide';

export const slide = () => {
  return (
    <Slide notes="Advanced workflows and Q&A session" transition="fade" networkBackground="full">
      <div className="relative z-10 flex flex-col text-center h-full px-24 py-8 text-left slide-scale-75">
        <h2 className="title">Advanced Tips & Vragen</h2>
      </div>
    </Slide>
  );
};
